import React, { Component } from "react";
import axios from "axios";
import Carousels from "./Carousel";
import Navs from "./movienav";
import queryString from "query-string";
import Left from "./LeftPanel";
import Navbar from "./Navbars";

let apiEndpoint =
  "https://us-central1-bkyow-22da6.cloudfunctions.net/app/movies";

class Movie extends Component {
  state = {
    langarr: ["Hindi", "English", "Punjabi", "Tamil"],
    formatarr: ["2D", "3D", "4DX"],
    genrearr: ["Action", "Comedy", "Adventure", "Biography"],
  };

  async componentDidMount() {
    let region = this.props.match.params
      ? this.props.match.params.region
      : "NCR";
    let query = this.props.location.search;
    console.log(region);
    let { data: resp } = await axios.get(apiEndpoint + "/" + region + query);
    if (resp) this.setState({ resp, region });
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      let region = this.props.match.params
        ? this.props.match.params.region
        : "NCR";

      let query = this.props.location.search;
      let { data: resp } = await axios.get(apiEndpoint + "/" + region + query);
      console.log(region);
      if (resp) this.setState({ resp, region });
    }
  }
  cbStructure(arr, value) {
    let temp = arr.map((val) => ({
      name: val,
      value: "",
    }));
    let val = value.split(",");
    for (let i = 0; i < arr.length; i++) {
      let obj = temp.find((vl) => vl.name === val[i]);
      if (obj) obj.value = true;
    }
    return temp;
  }
  addtoParms(params, newParamsName, newParamsValue) {
    if (newParamsValue) {
      params = params ? params + "&" : params + "?";
      params = params + newParamsName + "=" + newParamsValue;
    }
    return params;
  }
  handleNavSearch = (data) => {
    let { lang, genre, format } = queryString.parse(this.props.location.search);
    let params = this.addtoParms("", "q", data ? data : "");
    this.calltoParms(params, lang, genre, format);
  };
  handleLeft = (lang, genre, format) => {
    let langarr = lang.filter((vl) => vl.value);
    let filtlang = langarr.map((vl) => vl.name);
    let langstr = filtlang.join(",");
    let genrearr = genre.filter((vl) => vl.value);
    let filtgenre = genrearr.map((vl) => vl.name);
    let genrestr = filtgenre.join(",");
    let formatarr = format.filter((vl) => vl.value);
    let filtform = formatarr.map((vl) => vl.name);
    let formstr = filtform.join(",");
    this.calltoParms("", langstr, genrestr, formstr);
  };
  calltoParms(params, lang, genre, format) {
    let region = this.props.match.params
      ? this.props.match.params.region
      : "NCR";
    console.log(this.props.match.params);
    let path = "/movies/" + region;
    console.log("Data");
    params = this.addtoParms(params, "lang", lang);
    params = this.addtoParms(params, "genre", genre);
    params = this.addtoParms(params, "format", format);

    this.props.history.push({
      pathname: path,
      search: params,
    });
  }
  handleMovie = (vl) => {
    let reg = this.props.match.params.region;
    this.props.history.push({
      pathname: "/bookMovie/" + reg + "/" + vl,
      search: "",
      state: { ind: vl, region: reg },
    });
  };

  render() {
    let { genrearr, langarr, formatarr, region } = this.state;
    let { lang, genre, format } = queryString.parse(this.props.location.search);
    let genreopt = this.cbStructure(genrearr, genre ? genre : "");
    let langopt = this.cbStructure(langarr, lang ? lang : "");
    let formatopt = this.cbStructure(formatarr, format ? format : "");
    console.log(this.state);

    return (
      <div className="container-fluid">
        <Navbar onSubmit={this.handleNavSearch} value={region} />
        <div className="container">
          <Carousels />
        </div>
        <div className="d-sm-none d-md-block">
          {" "}
          <Navs />
        </div>

        <div className="row bg-light">
          <div className="col-lg-3 d-sm-none d-md-block ">
            <Left
              genre={genreopt}
              lang={langopt}
              format={formatopt}
              onSubmit={this.handleLeft}
            />
          </div>
          <div className="col-sm-12 col-lg-9">
            <div className="row row-fluid">
              {this.state.resp
                ? this.state.resp.map((vl, index) => (
                    <div
                      className="card col-xs-5 col-sm-5  col-lg-3 m-1"
                      style={{ width: "18rem" }}
                      onClick={() => this.handleMovie(index)}
                    >
                      <img
                        className="card-img-top"
                        src={vl.img}
                        alt="Card image cap"
                      />
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-5 col-6">
                            <i
                              className="fa fa-heart float-left text-danger"
                              aria-hidden="true"
                            ></i>
                            <span>{vl.rating}</span>
                          </div>
                          <div className="col-lg-7 col-12 text-center">
                            {vl.title}
                          </div>
                        </div>

                        <div className="row text-muted text-inline">
                          <div
                            className="col-lg-6 col-6 "
                            style={{ fontSize: "13px" }}
                          >
                            {vl.votes}
                            <span style={{ fontSize: "12px" }}>votes</span>
                          </div>
                          <div
                            className="col-lg-6 col-12"
                            style={{ fontSize: "12px" }}
                          >
                            {vl.desc}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Movie;
